webpackJsonp([4],{

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(306);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var routers = [{
  path: '/',
  meta: {
    title: '高等教育出版社有限公司'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(314)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/course',
  meta: {
    title: '高等教育出版社有限公司'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(313)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/test',
  meta: {
    title: '高等教育出版社有限公司'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(315)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

var RouterConfig = {
  mode: 'hash',
  routes: routers
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */](RouterConfig));

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(212)(
  /* script */
  null,
  /* template */
  __webpack_require__(305),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_lib_index_css__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vant_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_wechat__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_wechat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_wechat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment_lib__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment_lib__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["a" /* Collapse */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["b" /* CollapseItem */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["c" /* Radio */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["d" /* RadioGroup */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["e" /* NavBar */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["f" /* Button */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["g" /* Dialog */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["h" /* Col */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["i" /* Row */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant__["j" /* Icon */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_wechat___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment_lib___default.a);
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue___default.a);
  }
}).$mount('#app');

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 46,
	"./af.js": 46,
	"./ar": 53,
	"./ar-dz": 47,
	"./ar-dz.js": 47,
	"./ar-kw": 48,
	"./ar-kw.js": 48,
	"./ar-ly": 49,
	"./ar-ly.js": 49,
	"./ar-ma": 50,
	"./ar-ma.js": 50,
	"./ar-sa": 51,
	"./ar-sa.js": 51,
	"./ar-tn": 52,
	"./ar-tn.js": 52,
	"./ar.js": 53,
	"./az": 54,
	"./az.js": 54,
	"./be": 55,
	"./be.js": 55,
	"./bg": 56,
	"./bg.js": 56,
	"./bm": 57,
	"./bm.js": 57,
	"./bn": 58,
	"./bn.js": 58,
	"./bo": 59,
	"./bo.js": 59,
	"./br": 60,
	"./br.js": 60,
	"./bs": 61,
	"./bs.js": 61,
	"./ca": 62,
	"./ca.js": 62,
	"./cs": 63,
	"./cs.js": 63,
	"./cv": 64,
	"./cv.js": 64,
	"./cy": 65,
	"./cy.js": 65,
	"./da": 66,
	"./da.js": 66,
	"./de": 69,
	"./de-at": 67,
	"./de-at.js": 67,
	"./de-ch": 68,
	"./de-ch.js": 68,
	"./de.js": 69,
	"./dv": 70,
	"./dv.js": 70,
	"./el": 71,
	"./el.js": 71,
	"./en-SG": 72,
	"./en-SG.js": 72,
	"./en-au": 73,
	"./en-au.js": 73,
	"./en-ca": 74,
	"./en-ca.js": 74,
	"./en-gb": 75,
	"./en-gb.js": 75,
	"./en-ie": 76,
	"./en-ie.js": 76,
	"./en-il": 77,
	"./en-il.js": 77,
	"./en-nz": 78,
	"./en-nz.js": 78,
	"./eo": 79,
	"./eo.js": 79,
	"./es": 82,
	"./es-do": 80,
	"./es-do.js": 80,
	"./es-us": 81,
	"./es-us.js": 81,
	"./es.js": 82,
	"./et": 83,
	"./et.js": 83,
	"./eu": 84,
	"./eu.js": 84,
	"./fa": 85,
	"./fa.js": 85,
	"./fi": 86,
	"./fi.js": 86,
	"./fo": 87,
	"./fo.js": 87,
	"./fr": 90,
	"./fr-ca": 88,
	"./fr-ca.js": 88,
	"./fr-ch": 89,
	"./fr-ch.js": 89,
	"./fr.js": 90,
	"./fy": 91,
	"./fy.js": 91,
	"./ga": 92,
	"./ga.js": 92,
	"./gd": 93,
	"./gd.js": 93,
	"./gl": 94,
	"./gl.js": 94,
	"./gom-latn": 95,
	"./gom-latn.js": 95,
	"./gu": 96,
	"./gu.js": 96,
	"./he": 97,
	"./he.js": 97,
	"./hi": 98,
	"./hi.js": 98,
	"./hr": 99,
	"./hr.js": 99,
	"./hu": 100,
	"./hu.js": 100,
	"./hy-am": 101,
	"./hy-am.js": 101,
	"./id": 102,
	"./id.js": 102,
	"./is": 103,
	"./is.js": 103,
	"./it": 105,
	"./it-ch": 104,
	"./it-ch.js": 104,
	"./it.js": 105,
	"./ja": 106,
	"./ja.js": 106,
	"./jv": 107,
	"./jv.js": 107,
	"./ka": 108,
	"./ka.js": 108,
	"./kk": 109,
	"./kk.js": 109,
	"./km": 110,
	"./km.js": 110,
	"./kn": 111,
	"./kn.js": 111,
	"./ko": 112,
	"./ko.js": 112,
	"./ku": 113,
	"./ku.js": 113,
	"./ky": 114,
	"./ky.js": 114,
	"./lb": 115,
	"./lb.js": 115,
	"./lo": 116,
	"./lo.js": 116,
	"./lt": 117,
	"./lt.js": 117,
	"./lv": 118,
	"./lv.js": 118,
	"./me": 119,
	"./me.js": 119,
	"./mi": 120,
	"./mi.js": 120,
	"./mk": 121,
	"./mk.js": 121,
	"./ml": 122,
	"./ml.js": 122,
	"./mn": 123,
	"./mn.js": 123,
	"./mr": 124,
	"./mr.js": 124,
	"./ms": 126,
	"./ms-my": 125,
	"./ms-my.js": 125,
	"./ms.js": 126,
	"./mt": 127,
	"./mt.js": 127,
	"./my": 128,
	"./my.js": 128,
	"./nb": 129,
	"./nb.js": 129,
	"./ne": 130,
	"./ne.js": 130,
	"./nl": 132,
	"./nl-be": 131,
	"./nl-be.js": 131,
	"./nl.js": 132,
	"./nn": 133,
	"./nn.js": 133,
	"./pa-in": 134,
	"./pa-in.js": 134,
	"./pl": 135,
	"./pl.js": 135,
	"./pt": 137,
	"./pt-br": 136,
	"./pt-br.js": 136,
	"./pt.js": 137,
	"./ro": 138,
	"./ro.js": 138,
	"./ru": 139,
	"./ru.js": 139,
	"./sd": 140,
	"./sd.js": 140,
	"./se": 141,
	"./se.js": 141,
	"./si": 142,
	"./si.js": 142,
	"./sk": 143,
	"./sk.js": 143,
	"./sl": 144,
	"./sl.js": 144,
	"./sq": 145,
	"./sq.js": 145,
	"./sr": 147,
	"./sr-cyrl": 146,
	"./sr-cyrl.js": 146,
	"./sr.js": 147,
	"./ss": 148,
	"./ss.js": 148,
	"./sv": 149,
	"./sv.js": 149,
	"./sw": 150,
	"./sw.js": 150,
	"./ta": 151,
	"./ta.js": 151,
	"./te": 152,
	"./te.js": 152,
	"./tet": 153,
	"./tet.js": 153,
	"./tg": 154,
	"./tg.js": 154,
	"./th": 155,
	"./th.js": 155,
	"./tl-ph": 156,
	"./tl-ph.js": 156,
	"./tlh": 157,
	"./tlh.js": 157,
	"./tr": 158,
	"./tr.js": 158,
	"./tzl": 159,
	"./tzl.js": 159,
	"./tzm": 161,
	"./tzm-latn": 160,
	"./tzm-latn.js": 160,
	"./tzm.js": 161,
	"./ug-cn": 162,
	"./ug-cn.js": 162,
	"./uk": 163,
	"./uk.js": 163,
	"./ur": 164,
	"./ur.js": 164,
	"./uz": 166,
	"./uz-latn": 165,
	"./uz-latn.js": 165,
	"./uz.js": 166,
	"./vi": 167,
	"./vi.js": 167,
	"./x-pseudo": 168,
	"./x-pseudo.js": 168,
	"./yo": 169,
	"./yo.js": 169,
	"./zh-cn": 170,
	"./zh-cn.js": 170,
	"./zh-hk": 171,
	"./zh-hk.js": 171,
	"./zh-tw": 172,
	"./zh-tw.js": 172
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })

},[214]);


// WEBPACK FOOTER //
// app.4feeaa6118b10236deda.js